import { assoc, compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { integrationsClient } from '../../../../utils/apollo/api'
import { useCheckinHandlerResult } from '../ServiceContext'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertIntegration($input: IntegrationInput) {
    upsertIntegration(input: $input) {
      id
    }
  }
`

const cleanRequest = compose(
  pick(['id', 'service', 'code', 'client_id', 'redirect_uri']), //
  item => assoc('name', item.name, item),
  item => assoc('service', item.service?.toUpperCase(), item),
  item => assoc('code', item.queryString?.code, item),
  item => assoc('client_id', item.clientId, item),
  item => assoc('redirect_uri', item.redirectUri, item)
)

export const useSaveIntegrations = integrationId => {
  const [_handlerResult, setHandlerResult] = useCheckinHandlerResult()
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Integrations'], client: integrationsClient })

  const handleRequest = form => {
    setHandlerResult('loading')
    const input = cleanRequest({ ...form, id: integrationId })

    return request({ variables: { input } }).then(resp => {
      if (Boolean(resp.errors)) {
        closeModal()
        throw new Error(resp.errors)
      }

      return resp
    })
  }

  return [handleRequest, state]
}
